var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMouseScroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-5 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        opacity: 0.1;\n      }\n\n      .cls-4 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531",
    transform: "translate(13438 20345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1884",
    "data-name": "Rectangle 1884",
    className: "cls-1",
    transform: "translate(-13438 -20345)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 22,
    height: 34,
    rx: 11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 33,
    rx: 10.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3532",
    "data-name": "Group 3532",
    transform: "translate(25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1884-2",
    "data-name": "Rectangle 1884",
    className: "cls-2",
    width: 22,
    height: 34,
    rx: 11,
    transform: "translate(-13463 -20345)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1915",
    "data-name": "Rectangle 1915",
    className: "cls-3",
    width: 4,
    height: 8,
    rx: 2,
    transform: "translate(-13429 -20338)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseScroll);
export default __webpack_public_path__ + "static/media/Mouse_Scroll.c56c117c172832757493edddbd0a4224.svg";
export { ForwardRef as ReactComponent };